import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ServiceCategory from "../ChairLift/ServiceCategory";

const BoatingRoutes = () => {

  return (
    <div className="col-12">
           <ServiceCategory serviceId={8} />
    </div>
  );
};
export default BoatingRoutes
